import { Severity } from '@/api/domains/analyses';

export const sortFindingsBySeverity = (findings: any[]) => {
  const severityOrder: Record<Severity, number> = {
    CRITICAL: 0,
    HIGH: 1,
    MEDIUM: 2,
    LOW: 3
  };
  return [...findings].sort((a, b) => {
    return severityOrder[a.severity] - severityOrder[b.severity];
  });
};
